import React from 'react';
import {Box, Grid, List, ListItem, Typography} from '@deere/fuel-react';
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {toCapitalize} from "../shared/utils";

export const SummaryDeclineComments = ({classes, details}) => {
    return <AccordionDetails className={classes.accordionDetails}>
        <List disablePadding component="nav" aria-label="stakeholder card" className={classes.root}>
            {details && details.map((item, index) => {
                const rolesArr = item.roles.map(item => item.description)
                const unitsArr = item.units.map(item => `${item.description} - ${item.id}`)
                const commentData = item.comments
                return (
                    <ListItem style={{borderBottom: "1px solid #ccc", padding: ".75rem"}} key={index}>
                        <Grid container alignItems="center">
                            <Grid item xs={12}>
                                <Typography variant="label">
                                    {commentData}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <Typography color="secondary" size="sm">
                                    {toCapitalize(item.user.firstName)}, {toCapitalize(item.user.lastName)} | {rolesArr.join(', ')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Box display="flex" justifyContent="flex-end">
                                    <Typography color="secondary" size="sm">
                                        {unitsArr.join(', ')}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </ListItem>
                )
            })}
        </List>
    </AccordionDetails>;
}
